import { observer } from 'mobx-react';
import { FC, useCallback, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { formatPriceInProduct } from '../../helpers/orderProductModal';
import { modalStore } from 'src/mobx/modalStore';
import { IMenuProduct } from 'src/types/products';
import Image from 'src/view/components/Image/Image';
import { productUtils } from '~/utils/productUtils';
import './style.scss';

interface IProps {
  product?: IMenuProduct;
}

const CrossSellingProduct: FC<IProps> = observer(({ product }: IProps): JSX.Element => {
  const onProductClick = useCallback(() => {
    if (!product || !modalStore.orderProduct) return;

    modalStore.reopenOrderProduct({
      id: product.id,
      product,
      branch: modalStore.orderProduct.branch,
      onOpen: modalStore.orderProduct.onOpen,
      onClose: modalStore.orderProduct.onClose,
      onSubmit: modalStore.orderProduct.onSubmit,
      error: modalStore.orderProduct.error,
      isEdit: false,
      isDraft: false,
    });
  }, [product, modalStore.orderProduct]);

  const units = useMemo((): string | null => productUtils.getProductCalories(product), [product]);

  return (
    <div onClick={onProductClick} className="product-cross-selling-product">
      {/* image */}
      <Image wrapperClassName="product-cross-selling-product__image" aspectRatio={1.75} src={product?.image} />
      {/* name */}
      <p className="product-cross-selling-product__name mt-4 text-elipsis">{product?.name || <Skeleton width={100} />}</p>
      <div className="d-flex flex-row justify-content-between mt-3">
        {/* price */}
        <p className="product-cross-selling-product__price letter-spacing-12">
          {product ? formatPriceInProduct(product.price) : <Skeleton width={40} />}
        </p>
        {/* unit */}
        <p className="product-cross-selling-product__unit">{product ? units : <Skeleton width={30} />}</p>
      </div>
    </div>
  );
});

export default CrossSellingProduct;
